var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import React from 'react';
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes[ButtonTypes["button"] = 0] = "button";
    ButtonTypes[ButtonTypes["submit"] = 1] = "submit";
    ButtonTypes[ButtonTypes["reset"] = 2] = "reset";
    ButtonTypes[ButtonTypes["undefined"] = 3] = "undefined";
})(ButtonTypes || (ButtonTypes = {}));
const Button = (props) => {
    const { children, className, secondary, outline } = props, rest = __rest(props, ["children", "className", "secondary", "outline"]);
    const buttonClass = classnames(`form-button ${className || ''}`, {
        outline: outline,
        secondary: secondary,
    });
    return (React.createElement("button", Object.assign({ type: "button", className: buttonClass }, rest), children));
};
export default Button;
